<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <div class="content-section intro-section">
    <h2 class="section-title">Assurance Auto Personnelle</h2>
    <div class="intro-content">
      <p>
        Vous êtes un automobiliste et vous souhaitez vous assurer, mais vous ne trouvez pas d'assureurs ? <strong>BROKINS</strong> vous trouve l'assurance auto personnelle qu'il vous faut au prix le plus juste.
      </p>
      <p class="contact-text">
        <a href="/contact" class="contact-link">Contactez-nous !</a>
      </p>
      <p>
        Par ailleurs, nous avons de nombreux partenaires spécialisés dans ce <strong>créneau</strong> ainsi que des <strong>RISQUES AGGRAVÉS</strong> ! Malus de 3,5, Stupéfiants, Alcoolémie, Annulation de permis, suspension de permis, sanction judiciaire, jeune conducteur, véhicule puissant, véhicule puissant…
      </p>
    </div>
  </div>

  <div class="content-section advantages-section">
    <h3 class="advantages-title">DES AVANTAGES EXCLUSIFS :</h3>
    <ul class="advantages-list">
      <li>Larges critères de souscription : <strong>résilié compagnie, malussé, suspension ou annulation de permis, non-paiement, alcoolémie.</strong></li>
      <li>Garantie suspension de permis incluse dès la formule de base.</li>
      <li>Assistance 0 km et véhicule de remplacement en option.</li>
      <li>Souscription et carte verte immédiate <strong>pour les non-paiements de prime.</strong></li>
      <li>Réduction automatique de 50% sur la franchise dommage après 12 mois d'assurance sans sinistre responsable.</li>
      <li>Paiement du stage permis.</li>
    </ul>
  </div>

  <div class="content-section info-box">
    <p>
      En cas de besoin temporaire d'assurance auto, c'est-à-dire pour assurer le véhicule 1 jour, 1 semaine ou 90 jours d'affilée, il est sans doute conseillé d'assurer ce véhicule via une <a href="cac/assurance-auto-temporaire" class="info-link">Assurance Auto Temporaire</a>.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong>GENERALI, APRIL, AXA, FMA, NOVELIA SURAVENIR, NETVOX, ZEPHIR, XENASSUR, EURODOMMAGES.</strong>
    </p>
  </div>

</app-page-layout>
